export const environment = {
  production: true,
  URL_API: "https://api.paredesyasociados.com/api",
  SITE_URL: "https://www.paredesconstructores.com",
  CAPTCHA_KEY: "6LfAgMYrAAAAAMaE7vn4HKbdbV7TT3iR2NWKQ3qI",
  JWT_TOKEN: "Bearer eyJhbGciOiJIUzI1NiJ9.bWFzdGVy.JUuDRQnGk7UnjdexSwHI9URYjpHJy5drkEdCChv3INU"
};
